import { MILLISECONDS_PER_MINUTE } from '@/constants/date-time';

export default {
  state: {
    now: new Date()
  },
  mutations: {
    updateTime(state) {
      state.now = new Date;
    }
  },
  actions: {
    startOneMinuteInterval({ commit }) {
      // Check current time and calculate the delay until next minute
      const oneMinute = MILLISECONDS_PER_MINUTE
      const now = new Date();
      const delay = oneMinute - now % oneMinute;

      function start() {
        // Execute function now
        commit('updateTime');
        // and every minute
        setInterval(() => {
          commit('updateTime')
        }, oneMinute);
      }

      // Delay execution until we hit the minute mark
      setTimeout(start, delay);
    }
  }
};
